import { useMutation, useQueryClient } from '@tanstack/react-query';

const useCreateNews = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async newsData => {
      const response = await fetch(
        import.meta.env.VITE_PAWFRIENDS_API_ENDPOINT_NEWS,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(newsData),
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Failed to create news');
      }

      return response.json();
    },
    onSuccess: () => {
      // Refetch news nakon kreiranja nove vijesti
      queryClient.invalidateQueries(['news']);
    },
  });
};

export default useCreateNews;
